import { Team, GamePOI } from './model';
import {} from './version/api-version';
export var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["INITIAL"] = 0] = "INITIAL";
    UserStatus[UserStatus["UNIDENTIFIED"] = 1] = "UNIDENTIFIED";
    UserStatus[UserStatus["LOBBY"] = 2] = "LOBBY";
    UserStatus[UserStatus["OWNER_LOBBY"] = 3] = "OWNER_LOBBY";
    UserStatus[UserStatus["TEAM_LOBBY_LEADER"] = 4] = "TEAM_LOBBY_LEADER";
    UserStatus[UserStatus["TEAM_LOBBY"] = 5] = "TEAM_LOBBY";
    UserStatus[UserStatus["PLAYING"] = 6] = "PLAYING";
    UserStatus[UserStatus["GAME_ENDED"] = 7] = "GAME_ENDED";
})(UserStatus || (UserStatus = {}));
export const DEFAULT_STATE = {
    userId: null,
    status: UserStatus.INITIAL,
    team: null,
    score: 0,
    teams: null,
    maxDevices: null,
    urls: null,
    playerCount: 0,
    ownsGame: false,
    game: {
        ended: false,
        moderated: false,
        resultsDeclared: false,
        poi: [],
    },
};
export function getStateUpdater(version, store) {
    return (statusResponse) => {
        const status = (statusResponse !== null && determineUserStatus(statusResponse)) ||
            UserStatus.UNIDENTIFIED;
        const team = (statusResponse &&
            statusResponse.team &&
            Team.fromJson(statusResponse.team)) ||
            null;
        if (statusResponse) {
            version.update(statusResponse.version);
            const state = store.get();
            const newState = {
                ...state,
                userId: statusResponse.id,
                status,
                team,
                score: team?.score || 0,
                teams: (statusResponse?.teams &&
                    Team.fromJsonArray(statusResponse.teams)) ||
                    null,
                maxDevices: statusResponse?.maxDevices || null,
                urls: statusResponse.urls,
                playerCount: statusResponse.playerCount,
                ownsGame: statusResponse.ownsGame,
            };
            if ('game' in statusResponse) {
                newState.game = {
                    ...state.game,
                    ...statusResponse.game,
                };
            }
            else {
                newState.game = {
                    ...state.game,
                    ended: statusResponse.gameEnded,
                };
            }
            store.set(newState);
        }
        return status;
    };
}
function determineUserStatus(userObject) {
    if (userObject.isPlaying) {
        return UserStatus.PLAYING;
    }
    if (('game' in userObject && userObject.game.ended) ||
        ('gameEnded' in userObject && userObject.gameEnded)) {
        return UserStatus.GAME_ENDED;
    }
    if (userObject.team !== null) {
        if (userObject.team.leader === userObject.id) {
            return UserStatus.TEAM_LOBBY_LEADER;
        }
        return UserStatus.TEAM_LOBBY;
    }
    if (userObject.ownsGame) {
        return UserStatus.OWNER_LOBBY;
    }
    return UserStatus.LOBBY;
}
//# sourceMappingURL=state.js.map